export const sortByDate = (dataArray: any) => {
  return dataArray.sort((a: { createdAt: Date }, b: { createdAt: Date }) =>
    a.createdAt < b.createdAt ? 1 : -1,
  );
};
